'use strict'

import { useTitleStore } from '@/stores'
import { EventBus, Utils } from '@/lib'

export const TitleHelpers = {
    async getTitleByIdAsync(component, titleId, force = false) {
        const { getTitleByIdAsync } = useTitleStore()
        return await getTitleByIdAsync(component, titleId, force)
    },
    async getSourceTitles(component) {
        EventBus.$emit('showQuestLoader')
        const { getSourceTitles } = useTitleStore()
        const titles = await getSourceTitles(component)
        EventBus.$emit('hideQuestLoader')
        return titles
    },
    async getAllTitles(component) {
        EventBus.$emit('showQuestLoader')
        const { getAllTitles } = useTitleStore()
        const titles = await getAllTitles(component)
        EventBus.$emit('hideQuestLoader')
        return titles
    },
    getTitleName(titleId) {
        const { getTitleByIdSync } = useTitleStore()
        const title = getTitleByIdSync(titleId)
        if (title && title.title_name) {
            return title.title_name
        }
        return 'Missing title'
    },
    validateTitleForQuest(title) {
        return (title && title.is_configured)
    },
    createEmptyTitle() {
        return {
            "available_languages": [],
            "images": {},
            "notification_uri": "",
            "ref_link": "",
            "title_id": "",
            "tracked_metrics": []
        }
    },
    prepareTitle(title, mappings) {
        let prepared = {...title}
        const unmapped = this.unmapTitleMappings(mappings)
        prepared = Object.assign({}, title, unmapped)
        prepared.title_id = parseInt(title.title_id, 10)
        const invalidTitleProps = [
            'title_name',
            "short_title",
            "studio_name",
            "studio_short_name",
            "studio_prefix",
            "studio_id",
            "api_usage_plan_type",
            "is_configured",
            "client_api_key",
            "client_api_key_id",
            "server_api_key",
            "server_api_key_id",
            "client_api_key_2",
            "client_api_key_2_id",
            "server_api_key_2",
            "server_api_key_2_id",
            "client_api_key_3",
            "client_api_key_3_id",
            "server_api_key_3",
            "server_api_key_3_id",
            "title",
            "studio",
        ]
        for (let i = 0; i < invalidTitleProps.length; i++) {
            let prop = invalidTitleProps[i]
            delete prepared[prop]
        }
        return prepared
    },
    unmapTitleMappings(mappings) {
        return Utils.unmap(mappings)
    }
}
